import { createFileRoute } from "@tanstack/react-router";
import QuestionsLayout from "@/app/inspections/[id]/questions/layout";
import Page from "@/app/inspections/[id]/questions/page";

export const Route = createFileRoute("/inspections/$id/questions")({
  component: () => (
    <QuestionsLayout>
      <Page />
    </QuestionsLayout>
  ),
});
